import { useState } from 'react'
import type { SectionProps } from './types'

export function GuardSection({ draft, setDraft }: SectionProps) {
  // 入力途中の文字列（読点・カンマ）はローカルに持つ。サーバー値で draft を
  // 再シードしたときは親が key を変えてこのコンポーネントを作り直す
  const [ngInput, setNgInput] = useState(draft.guard.customNgWords.join('、'))
  return (
    <div className="gm-card p-4 md:p-5">
      <p className="font-bold">安全チェック</p>
      <p className="mt-1 text-sm text-ink-muted">投稿前の法令・規約チェックの感度です。</p>
      <label className="mt-3 flex items-center gap-2 text-sm">
        <input type="checkbox" className="accent-primary" checked={draft.guard.yakkiMode}
          onChange={e => setDraft({ ...draft, guard: { ...draft.guard, yakkiMode: e.target.checked } })} />
        薬機法モード（化粧品・健康食品などを扱う場合はオン推奨）
      </label>
      <div className="mt-4 grid gap-1.5 text-sm">
        <label htmlFor="guard-ng-words" className="text-[13px] font-bold">追加 NG ワード（読点・カンマ区切り）</label>
        <input id="guard-ng-words" value={ngInput}
          onChange={e => {
            setNgInput(e.target.value)
            const words = e.target.value.split(/[、,]/).map(w => w.trim()).filter(Boolean)
            setDraft({ ...draft, guard: { ...draft.guard, customNgWords: words } })
          }}
          className="gm-input"
          placeholder="例: 激安、最強" />
      </div>
    </div>
  )
}
